// extracted by mini-css-extract-plugin
export var bundleWrap = "emptyBundle-module--bundleWrap--L7Dmu";
export var emptyBundle = "emptyBundle-module--emptyBundle--pMIIp";